import { DataModel } from "../../base/index.js";
import type {
  ImageMetaData,
  ImageMetaEnvData,
  ImageMetaPortData,
  ImageMetaVolumeData,
} from "./types.js";

export class ImageMeta extends DataModel<ImageMetaData> {
  public readonly imageRef: string;
  public readonly command?: string;
  public readonly entrypoint?: string;
  public readonly envs?: ImageMetaEnvData[];
  public readonly ports?: ImageMetaPortData[];
  public readonly volumes?: ImageMetaVolumeData[];

  public constructor(data: ImageMetaData, imageRef: string) {
    super(data);
    this.imageRef = imageRef;
    this.command = data.command?.join(" ");
    this.entrypoint = data.entrypoint?.join(" ");
    this.envs = data.env;
    this.ports = data.exposedPorts;
    this.volumes = data.volumes;
  }
}
